import { Controller } from "@hotwired/stimulus"

// This controller is used to trigger an event when a filter is added, the event is used with stimulus actions to
// trigger other stimulus controllers.
export default class extends Controller {
  add(event) {
    this.dispatch("add", { detail: { name: event.params.name }})
  }
}
